// @ts-nocheck
import React from 'react'
import { connect } from 'react-redux'

import { LoginPage } from 'components/auth/LoginPage/LoginPage'
import { Loader } from 'components/shared/Loader/Loader'

import { AUTHSTATUS, getUser, requestUser } from 'ducks/auth'

// Wrapper component to hide pages that require login
const LoginRequired = ({ children, authState, requestUser }) => {
  // fetch user from api if there's no logged in user
  if (!authState || authState === AUTHSTATUS.UNKNOWN) setTimeout(requestUser, 0)

  switch (authState) {
    case AUTHSTATUS.LOGGED_IN:
      return children
    case AUTHSTATUS.UNKNOWN:
    case AUTHSTATUS.PENDING:
      return <Loader isBig />
    default:
      return <LoginPage />
  }
}

export default connect(
  getUser,
  { requestUser },
)(LoginRequired)